import React from 'react';
// import contact from '../../contactbg.png';
// import { BsLinkedin } from 'react-icons/bs';
// import { BsFacebook } from 'react-icons/bs';
// import { MdEmail } from 'react-icons/md';
import Email from './Email';

const ContactMe = () => {
    return (
        <div id='contact'>
            <div className='contact-div md:mx-24 md:flex md:flex-col justify-center items-center'>
                <div className='-ml-16 mb-8'>
                    <h1 className='header text-7xl mx-auto'>Get in</h1>
                    <h2 className='about font-extrabold md:text-7xl text-4xl ml-20 md:ml-44 -mt-5'>TOUCH</h2>
                </div>
                {/* <div className='ml-48 md:mt-10 mt-8'>
                        <div className='flex gap-5 text-xl'>
                            <BsLinkedin className='mb-5 text-white md:text-black' />
                            <a href="https://www.linkedin.com/in/nusrat-jahan-72438b229" className='-mt-2 text-white md:text-black'>LinkedIn</a>
                        </div>
                        <div className='flex gap-5 text-xl'>
                            <BsFacebook className='mb-5 text-white md:text-black' />
                            <a href="https://www.facebook.com/profile.php?id=100044216043681" className='-mt-2 text-white md:text-black'>Facebook</a>
                        </div>
                        <div className='flex gap-5 text-xl'>
                            <MdEmail className='mb-5 text-white md:text-black' />
                            <a href="mailto:nusratjahanmithila@gmail.com" className='-mt-2 text-white md:text-black'>Email</a>
                        </div>
                    </div> */}
                <Email></Email>
            </div>
        </div>
    );
};

export default ContactMe;